"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datamasterFarmDetailView = _interopRequireDefault(require("datamaster-farm-detail-view"));

var _translate = _interopRequireDefault(require("../translate"));

var _advancedFetch = _interopRequireDefault(require("../advanced-fetch"));

var _scrollTo = _interopRequireDefault(require("../scroll-to"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _footer = _interopRequireDefault(require("../footer"));

var _translateUrl = _interopRequireDefault(require("../footer/translateUrl"));

var _conf = _interopRequireDefault(require("../../conf"));

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DetailView = /*#__PURE__*/function (_React$Component) {
  _inherits(DetailView, _React$Component);

  function DetailView(props) {
    var _this;

    _classCallCheck(this, DetailView);

    _this = _possibleConstructorReturn(this, (DetailView.__proto__ || Object.getPrototypeOf(DetailView)).call(this, props));
    _this.state = {
      loading: false,
      farm: {
        location: {
          lat: null,
          lon: null
        },
        cultures: [],
        animals: [],
        zones: [],
        otherlanguages: [],
        productiontype: {},
        documents: [],
        facebook_link: null,
        instagram_link: null,
        twitter_link: null,
        youtube_link: null,
        tiktok_link: null,
        programs: [],
        productionlabels: [],
        brunch: {
          applicationphoneprio1: '',
          applicationphoneprio2: '',
          applicationphoneprio3: '',
          applicationemail: '',
          salutation: {},
          brunchwebsite: '',
          first_name: '',
          last_name: '',
          street: '',
          zip: '',
          city: '',
          canton: [],
          coorganisator: '',
          brunchlocation: '',
          paymentmethod: [],
          location: {
            lat: null,
            lon: null
          },
          comment: '',
          soldout: false,
          soldoutStr: '',
          costperadult: '',
          costperchild: '',
          maxamountofguests: null,
          placedetails: [],
          directionspublictransport: '',
          directions: '',
          offer: ''
        },
        vomhof: {
          id: null,
          offers: [],
          outlets: [],
          vacations: [],
          paymentmethod: [],
          shopdescription: '',
          openinghours: '',
          onlineshop: ''
        },
        schub: {
          comment: '',
          themes: [],
          targetGroups: [],
          infrastructures: [],
          themesextended: '',
          commentinfrastructure: '',
          salutation: {},
          first_name: '',
          last_name: '',
          street: '',
          zip: '',
          city: '',
          canton: [],
          coorganisator: '',
          schublocation: '',
          location: {
            lat: null,
            lon: null
          },
          placedetails: [],
          directionspublictransport: '',
          directions: ''
        },
        stallvisite: {
          openinghours: '',
          miscellaneous: '',
          addresstype: '',
          salutation: {},
          eventlocation: '',
          first_name: '',
          last_name: '',
          street: '',
          zip: '',
          city: '',
          canton: {},
          directions: '',
          directionspublictransport: '',
          website: '',
          farmvisit: '',
          images: [],
          documents: []
        },
        toh: {
          openinghours: '',
          salutation: {},
          coorganisator: '',
          first_name: '',
          last_name: '',
          street: '',
          zip: '',
          city: '',
          canton: {},
          directions: '',
          directionspublictransport: '',
          website: '',
          eventlocation: '',
          offers: '',
          comment: ''
        },
        projects: {
          vomhof: false,
          brunch: false,
          schub: false,
          stallvisite: false,
          lockpfosten: false,
          toh: false
        }
      }
    };
    _this.changeProjectInUrl = _this.changeProjectInUrl.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DetailView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props$match$par = this.props.match.params,
          pathname = _this$props$match$par.pathname,
          projectname = _this$props$match$par.projectname;

      if (!projectname) {
        projectname = '';
      }

      var projectKeys = _conf.default.projectKeys; // check if projectname is set as a param and if the key exists
      // otherwise redirect user back to home sweet home

      if (projectname && !Object.hasOwn(projectKeys, projectname)) {
        this.props.history.replace('/' + this.props.i18n.language);
      }

      this.setState(function (prev) {
        prev.loading = true;
        return prev;
      });
      (0, _advancedFetch.default)("/api/".concat(this.props.i18n.language, "/farm/").concat(pathname, "/").concat(projectname), {
        credentials: 'include'
      }).then(function (result) {
        _this2.setState(function (prev) {
          prev.farm = result;
          prev.loading = false;
          return prev;
        });
      }).catch(function (err) {
        if (err.error.status === 404) _this2.props.history.replace('/404');
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (prevProps.lng === this.props.lng) {
        return;
      }

      var _this$props$match$par2 = this.props.match.params,
          pathname = _this$props$match$par2.pathname,
          projectname = _this$props$match$par2.projectname;

      if (!projectname) {
        projectname = '';
      }

      this.setState(function (prev) {
        prev.loading = true;
      });
      (0, _advancedFetch.default)("/api/".concat(this.props.i18n.language, "/farm/").concat(pathname, "/").concat(projectname), {
        credentials: 'include'
      }).then(function (result) {
        _this3.setState(function (prev) {
          prev.farm = result;
          prev.laoding = false;
          return prev;
        });
      }).catch(function (err) {
        if (err.error.status === 404) _this3.props.history.replace('/404');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var pathname = this.props.match.params.pathname;
      var theme = document.body.classList.item(0);
      var closeLink = "/".concat(this.props.i18n.language, "#").concat(this.state.farm.id); // return link with filters & farm id for scrolling

      if (this.props.detailViewPath.length > 0) {
        var detailViewUrl = (0, _translateUrl.default)(this.props.detailViewPath, this.props.detailViewSearch, this.props.i18n.language, this.props);
        closeLink = "".concat(detailViewUrl, "#").concat(this.state.farm.id);
      }

      if (this.state.loading) {
        return /*#__PURE__*/_react.default.createElement(_loader.default, null);
      }

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_datamasterFarmDetailView.default, _extends({}, this.props, {
        farm: this.state.farm,
        scrollTo: _scrollTo.default,
        closeLink: closeLink,
        pathToDetail: "/farm/".concat(pathname),
        programCases: [1, 2, 3],
        theme: theme,
        changeUrl: this.changeProjectInUrl,
        projectKeys: _conf.default.projectKeys
      })), /*#__PURE__*/_react.default.createElement(_footer.default, {
        match: this.props.match,
        history: this.props.history
      }));
    }
  }, {
    key: "changeProjectInUrl",
    value: function changeProjectInUrl(project) {
      // split url into parts
      var pathParts = this.props.location.pathname.split('/'); // if projectname exists overwrite the last part
      // otherwise add project to url (legacy)

      if (this.props.match.params.projectname) {
        pathParts[pathParts.length - 1] = project;
      } else {
        pathParts[pathParts.length] = project;
      }

      var newPath = pathParts.join('/');
      this.props.history.push(newPath);
    }
  }]);

  return DetailView;
}(_react.default.Component);

DetailView.propTypes = {
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string
  }),
  history: _propTypes.default.object,
  detailViewPath: _propTypes.default.string,
  detailViewSearch: _propTypes.default.string,
  t: _propTypes.default.func.isRequired,
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      projectname: _propTypes.default.string
    })
  }),
  lng: _propTypes.default.string
};
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 * @returns {{languages: Array|*|string[]}}
 */

var mapStateToProps = function mapStateToProps(state) {
  return (0, _lodash.default)({}, state.farm, {
    iframe: state.iframe
  });
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(DetailView));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/detail-view/index.js
// module id = 615
// module chunks = 0